import { render, staticRenderFns } from "./SaveMockPractical.vue?vue&type=template&id=f3ac94a2&"
import script from "./SaveMockPractical.vue?vue&type=script&lang=js&"
export * from "./SaveMockPractical.vue?vue&type=script&lang=js&"
import style0 from "./SaveMockPractical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports